import type { PaperRecoveryInput } from '@didto/domain';
import { Checkbox, Field, Input, Pills } from '@didto/ui';

/**
 * ADR-040: the order on the screen was taken on paper while the app could not reach the server. It goes into the shift
 * taking money on this tablet and today's business day; its lines never reach a station (they were made on paper).
 */
export function PaperOrderFields({
  value,
  onChange,
}: {
  value: PaperRecoveryInput | null;
  onChange: (next: PaperRecoveryInput | null) => void;
}) {
  return (
    <div className="pos-paper d-stack d-stack--tight" data-testid="paper-order">
      <Checkbox
        checked={!!value}
        onChange={(on) => onChange(on ? { time: '', estimated: true, slip: '' } : null)}
        label="From paper (taken while the app was offline)"
        testId="paper-toggle"
      />
      {value && (
        <>
          <div className="pos-paper__fields">
            <Field label="Time on the paper">
              {(id) => (
                <Input
                  id={id}
                  type="time"
                  value={value.time}
                  onChange={(e) => onChange({ ...value, time: e.target.value })}
                  data-testid="paper-time"
                />
              )}
            </Field>
            <Field label="Slip number" help="If the paper has one">
              {(id) => (
                <Input
                  id={id}
                  value={value.slip}
                  maxLength={20}
                  inputMode="text"
                  onChange={(e) => onChange({ ...value, slip: e.target.value })}
                  data-testid="paper-slip"
                />
              )}
            </Field>
          </div>
          <Pills
            ariaLabel="How exact is the time"
            value={value.estimated ? 'about' : 'exact'}
            onChange={(v) => onChange({ ...value, estimated: v === 'about' })}
            options={[
              { value: 'about', label: 'About' },
              { value: 'exact', label: 'Exact' },
            ]}
          />
          <p className="d-help">
            Kept with the order as taken on paper; the order is entered now and nothing goes to the
            kitchen. Only orders from this shift, today. Older ones: tell the owner.
          </p>
        </>
      )}
    </div>
  );
}
